import register from '@kpsys/angularjs-register';

import loansRoutes from './loans.routes';

/**
 * @ngdoc module
 * @name uc.loans
 * @module uc.loans
 *
 * @description
 * Loans list UC
 */
export default register('uc.loans')
    .config(loansRoutes)
    .name();